export default __webpack_public_path__ + "static/table-b0464d61b016ea81fd72ff22aeaccbe9.png";